import { render, staticRenderFns } from "./ScaniaNextGenGauges.vue?vue&type=template&id=c5a19d42&"
import script from "./ScaniaNextGenGauges.vue?vue&type=script&lang=js&"
export * from "./ScaniaNextGenGauges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports